/** truncate long string to short */
export const truncate = (value, limit = 50, byWord = false) => {
    /* break string to list characters */
    const list = byWord ? value.split(' ') : value.split('');
    /* detect we need add dots at end string or not */
    const prefix = list.length > limit ? '...' : '';
    /* join again */
    return list.slice(0, limit).join(byWord ? ' ' : '') + prefix;
  };

  import { DateTime } from 'luxon';

  /** convert ISO date string into locale */
  export const dateChangeTz = (iso, tz = 'utc') => {
    return DateTime.fromISO(iso, { setZone: true }).setZone(tz);
  };
  
  export const dateFormat = (
    value,
    type = 'DATE_SHORT',
    userTz,
  ) => {
    /* get format object */
    const format = DateTime[type];
    /* if has store, try to convert to correct timezone */
    const timezone = userTz || 'UTC';
    /* convert to time */
    return dateChangeTz(value, timezone).toLocaleString(format);
  };
  
  export const dateSince = (value, userTz) => {
    /* if has store, try to convert to correct timezone */
    const timezone = userTz || 'UTC';
    /* convert to time */
    const date = DateTime.fromISO(value, { setZone: true });
    // const dateConverted = date.setZone(timezone);
    const base = DateTime.local().setZone(timezone);
    return date.toRelative({ base });
  };
  